/**
 * Product Section Logic - Guitar Tech
 * Gallery, Variant Switching, Add-to-Cart, Reassurance, and Sticky Floating Bar
 */
function initProductSection(section) {
  if (!section || section.dataset.initialized === 'true') return;
  section.dataset.initialized = 'true';

  const sectionId = section.dataset.sectionId || section.id.replace('ProductSection-', '');

  // Data variants & inventory
  const variantsScript = document.getElementById('ProductVariantsJson-' + sectionId) || section.querySelector('[id^="ProductVariantsJson-"]');
  const variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];

  const inventoryScript = document.getElementById('ProductVariantsInventory-' + sectionId) || section.querySelector('[id^="ProductVariantsInventory-"]');
  const variantsInventory = inventoryScript ? JSON.parse(inventoryScript.textContent) : {};

  // Elements
  const variantInput = document.getElementById('ProductVariantInput-' + sectionId) || section.querySelector('[id^="ProductVariantInput-"]');
  const priceEl = document.getElementById('ProductPrice-' + sectionId) || section.querySelector('[id^="ProductPrice-"]');
  const comparePriceEl = document.getElementById('ComparePrice-' + sectionId) || section.querySelector('[id^="ComparePrice-"]');
  const stockStatusEl = document.getElementById('StockStatus-' + sectionId) || section.querySelector('[id^="StockStatus-"]');
  const addBtn = document.getElementById('AddToCart-' + sectionId) || section.querySelector('[id^="AddToCart-"]');
  const floatingBar = document.getElementById('FloatingQuickBar-' + sectionId) || section.querySelector('[id^="FloatingQuickBar-"]');
  const floatingBtn = floatingBar ? floatingBar.querySelector('.js-floating-add-btn') : null;

  // Gallery elements
  const thumbnails = section.querySelectorAll('.product-gallery__thumbnail-btn');
  const imageThumbnails = section.querySelectorAll('.product-gallery__thumbnail-btn:not(.product-gallery__thumbnail-btn--video)');
  const slides = section.querySelectorAll('.product-gallery__slide');
  const dots = section.querySelectorAll('.product-gallery__dot');
  const zoomBtn = document.getElementById('GalleryZoomBtn-' + sectionId) || section.querySelector('[id^="GalleryZoomBtn-"]');
  const zoomModal = document.getElementById('GalleryZoomModal-' + sectionId) || section.querySelector('[id^="GalleryZoomModal-"]');
  const zoomModalImg = document.getElementById('GalleryZoomModalImg-' + sectionId) || section.querySelector('[id^="GalleryZoomModalImg-"]');
  const shimmer = section.querySelector('.js-gallery-shimmer');

  // Remove shimmer placeholder once main image is ready
  const mainImg = section.querySelector('.product-gallery__slide.is-active img');
  if (mainImg) {
    if (mainImg.complete) {
      shimmer?.classList.add('is-hidden');
    } else {
      mainImg.addEventListener('load', () => shimmer?.classList.add('is-hidden'), { once: true });
    }
  }

  // Clear thumbnail shimmer when loaded
  thumbnails.forEach((btn) => {
    const img = btn.querySelector('img');
    if (img) {
      if (img.complete) {
        btn.classList.add('is-loaded');
      } else {
        img.addEventListener('load', () => btn.classList.add('is-loaded'), { once: true });
      }
    }
  });

  // 1. Gallery Switcher & Mobile Swipe Navigation
  let currentGalleryIndex = 0;
  const initialActiveSlide = section.querySelector('.product-gallery__slide.is-active');
  if (initialActiveSlide) {
    currentGalleryIndex = parseInt(initialActiveSlide.dataset.slideIndex, 10) || 0;
  }

  function setActiveMedia(index, direction) {
    if (index < 0 || index >= slides.length) return;
    currentGalleryIndex = index;

    imageThumbnails.forEach((t, i) => t.classList.toggle('is-active', i === index));
    slides.forEach((s, i) => {
      const isActive = i === index;
      s.classList.toggle('is-active', isActive);
      if (isActive && direction) {
        s.dataset.slideDirection = direction;
      }
    });
    dots.forEach((d, i) => d.classList.toggle('is-active', i === index));

    // Scroll active thumbnail into view in the thumbnail rail on mobile & desktop
    const activeThumb = imageThumbnails[index];
    if (activeThumb && activeThumb.offsetParent !== null) {
      activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }

  function nextGallerySlide() {
    if (slides.length <= 1) return;
    const nextIdx = (currentGalleryIndex + 1) % slides.length;
    setActiveMedia(nextIdx, 'next');
  }

  function prevGallerySlide() {
    if (slides.length <= 1) return;
    const prevIdx = (currentGalleryIndex - 1 + slides.length) % slides.length;
    setActiveMedia(prevIdx, 'prev');
  }

  imageThumbnails.forEach((btn) => {
    btn.addEventListener('click', () => {
      const index = parseInt(btn.dataset.mediaIndex, 10);
      if (!isNaN(index)) {
        const direction = index > currentGalleryIndex ? 'next' : 'prev';
        setActiveMedia(index, direction);
      }
    });
  });

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      const index = parseInt(dot.dataset.dotIndex, 10);
      if (!isNaN(index)) {
        const direction = index > currentGalleryIndex ? 'next' : 'prev';
        setActiveMedia(index, direction);
      }
    });
  });

  // Mobile Touch Swipe Functionality for Main Gallery Viewport
  const mainViewport = section.querySelector('.product-gallery__main-viewport');
  if (mainViewport && slides.length > 1) {
    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let touchEndY = 0;
    let isHorizontalSwipe = false;
    let preventClick = false;
    let preventClickTimer = null;

    mainViewport.addEventListener(
      'touchstart',
      (e) => {
        if (e.touches.length !== 1) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchEndX = touchStartX;
        touchEndY = touchStartY;
        isHorizontalSwipe = false;
      },
      { passive: true }
    );

    mainViewport.addEventListener(
      'touchmove',
      (e) => {
        if (e.touches.length !== 1) return;
        touchEndX = e.touches[0].clientX;
        touchEndY = e.touches[0].clientY;

        const diffX = touchEndX - touchStartX;
        const diffY = touchEndY - touchStartY;
        const absDiffX = Math.abs(diffX);
        const absDiffY = Math.abs(diffY);

        if (absDiffX > absDiffY && absDiffX > 10) {
          isHorizontalSwipe = true;
        }
      },
      { passive: true }
    );

    mainViewport.addEventListener(
      'touchend',
      () => {
        const deltaX = touchEndX - touchStartX;
        const deltaY = touchEndY - touchStartY;
        const absX = Math.abs(deltaX);
        const absY = Math.abs(deltaY);

        // Threshold of 35px horizontal movement, predominantly horizontal
        if (absX >= 35 && absX > absY) {
          preventClick = true;
          clearTimeout(preventClickTimer);
          preventClickTimer = setTimeout(() => {
            preventClick = false;
          }, 350);

          if (deltaX < 0) {
            nextGallerySlide();
          } else {
            prevGallerySlide();
          }
        } else if (isHorizontalSwipe) {
          preventClick = true;
          clearTimeout(preventClickTimer);
          preventClickTimer = setTimeout(() => {
            preventClick = false;
          }, 350);
        }
      },
      { passive: true }
    );

    // Suppress zoom-click if a swipe gesture occurred
    mainViewport.addEventListener(
      'click',
      (e) => {
        if (preventClick) {
          e.preventDefault();
          e.stopPropagation();
          preventClick = false;
        }
      },
      true
    );
  }

  // Video Modal Logic for Product Gallery
  const videoBtn = section.querySelector('.js-product-gallery-video-btn');
  const videoModal =
    document.getElementById('ProductVideoModal-' + sectionId) ||
    document.getElementById('VideoSpecsModal-' + sectionId) ||
    document.querySelector('.product-video-modal') ||
    document.querySelector('.video-specs-modal');
  const videoPlayerContainer =
    document.getElementById('ProductVideoPlayer-' + sectionId) ||
    document.getElementById('VideoSpecsPlayer-' + sectionId) ||
    (videoModal ? videoModal.querySelector('.video-specs-modal__player') : null);

  if (videoBtn && videoModal && videoPlayerContainer) {
    const videoId = videoBtn.dataset.videoId;

    function openVideoModal() {
      if (videoId) {
        const embedSrc =
          'https://www.youtube.com/embed/' +
          encodeURIComponent(videoId) +
          '?autoplay=1&enablejsapi=1&rel=0';
        videoPlayerContainer.innerHTML =
          '<iframe src="' +
          embedSrc +
          '" class="video-specs-modal__iframe" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen title="' +
          (videoBtn.getAttribute('aria-label') || 'Vidéo') +
          '"></iframe>';
      }
      videoModal.classList.add('is-active');
      videoModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      const closeBtn = videoModal.querySelector('.video-specs-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeVideoModal() {
      videoModal.classList.remove('is-active');
      videoModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      // Clear iframe immediately to terminate playback and audio
      videoPlayerContainer.innerHTML = '';
      videoBtn.focus();
    }

    videoBtn.addEventListener('click', (e) => {
      e.preventDefault();
      openVideoModal();
    });

    videoModal.querySelectorAll('.js-product-video-modal-close, .js-video-modal-close').forEach((closeEl) => {
      closeEl.addEventListener('click', (e) => {
        e.preventDefault();
        closeVideoModal();
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && videoModal.classList.contains('is-active')) {
        closeVideoModal();
      }
    });
  }

  // 2. Fullscreen Zoom (Impact-inspired lightbox with deep zoom & thumbnail switching)
  if (zoomModal && zoomModalImg) {
    let currentZoomIndex = 0;
    let isZoomed = false;
    const zoomWrapper = section.querySelector('.js-zoom-toggle');
    const counterCurrent = zoomModal.querySelector('.js-zoom-current');
    const prevBtn = zoomModal.querySelector('.js-zoom-prev');
    const nextBtn = zoomModal.querySelector('.js-zoom-next');
    const totalSlides = slides.length;

    function resetZoom() {
      isZoomed = false;
      if (zoomWrapper) {
        zoomWrapper.classList.remove('is-zoomed');
        zoomWrapper.style.transform = '';
        zoomWrapper.style.transformOrigin = 'center center';
      }
    }

    function updateZoomSlide(index) {
      if (!slides[index]) return;
      currentZoomIndex = index;
      const slide = slides[currentZoomIndex];
      const highResUrl = slide.dataset.zoomSrc;
      const slideImg = slide.querySelector('img');

      // Reset zoom level on image change
      resetZoom();

      // Update image
      if (highResUrl) {
        zoomModalImg.src = highResUrl;
      } else if (slideImg) {
        zoomModalImg.src = slideImg.src;
      }
      if (slideImg && slideImg.alt) {
        zoomModalImg.alt = slideImg.alt;
      }

      // Update counter
      if (counterCurrent) {
        counterCurrent.textContent = currentZoomIndex + 1;
      }

      // Keep main gallery in sync
      setActiveMedia(currentZoomIndex);
    }

    function openZoom(startIndex) {
      let activeIdx = 0;
      if (typeof startIndex === 'number') {
        activeIdx = startIndex;
      } else {
        const activeSlide = section.querySelector('.product-gallery__slide.is-active');
        if (activeSlide) {
          activeIdx = parseInt(activeSlide.dataset.slideIndex, 10) || 0;
        }
      }
      updateZoomSlide(activeIdx);
      zoomModal.classList.add('is-open');
      zoomModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeZoom() {
      resetZoom();
      zoomModal.classList.remove('is-open');
      zoomModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function nextSlide() {
      if (totalSlides <= 1) return;
      const nextIdx = (currentZoomIndex + 1) % totalSlides;
      updateZoomSlide(nextIdx);
    }

    function prevSlide() {
      if (totalSlides <= 1) return;
      const prevIdx = (currentZoomIndex - 1 + totalSlides) % totalSlides;
      updateZoomSlide(prevIdx);
    }

    // Open triggers
    if (zoomBtn) {
      zoomBtn.addEventListener('click', () => openZoom());
    }
    section.querySelectorAll('.js-zoomable-img').forEach((img) => {
      img.addEventListener('click', (e) => {
        const slide = e.target.closest('.product-gallery__slide');
        const idx = slide ? parseInt(slide.dataset.slideIndex, 10) : 0;
        openZoom(idx);
      });
    });

    // Close triggers
    zoomModal.querySelectorAll('.js-close-zoom').forEach((el) => {
      el.addEventListener('click', closeZoom);
    });

    // Navigation buttons
    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        prevSlide();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        nextSlide();
      });
    }

    // Deep Zoom toggle & pan
    if (zoomWrapper) {
      zoomWrapper.addEventListener('click', (e) => {
        if (isZoomed) {
          resetZoom();
        } else {
          isZoomed = true;
          zoomWrapper.classList.add('is-zoomed');
          const rect = zoomModalImg.getBoundingClientRect();
          const x = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100));
          const y = Math.max(0, Math.min(100, ((e.clientY - rect.top) / rect.height) * 100));
          zoomWrapper.style.transformOrigin = `${x}% ${y}%`;
          zoomWrapper.style.transform = 'scale(2.2)';
        }
      });

      zoomWrapper.addEventListener('mousemove', (e) => {
        if (!isZoomed) return;
        const rect = zoomModalImg.getBoundingClientRect();
        const x = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100));
        const y = Math.max(0, Math.min(100, ((e.clientY - rect.top) / rect.height) * 100));
        zoomWrapper.style.transformOrigin = `${x}% ${y}%`;
      });
    }

    // Keyboard navigation (Esc to close, Left/Right arrows to switch)
    document.addEventListener('keydown', (e) => {
      if (!zoomModal.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeZoom();
      if (e.key === 'ArrowRight') nextSlide();
      if (e.key === 'ArrowLeft') prevSlide();
    });

    // Touch swipe support
    let touchStartX = 0;
    zoomModal.addEventListener(
      'touchstart',
      (e) => {
        touchStartX = e.changedTouches[0].screenX;
      },
      { passive: true }
    );

    zoomModal.addEventListener(
      'touchend',
      (e) => {
        if (isZoomed) return;
        const touchEndX = e.changedTouches[0].screenX;
        if (touchStartX - touchEndX > 50) {
          nextSlide();
        } else if (touchEndX - touchStartX > 50) {
          prevSlide();
        }
      },
      { passive: true }
    );
  }

  // 3. Variant Pills Selection
  const optionPills = section.querySelectorAll('.option-pill');
  optionPills.forEach((pill) => {
    pill.addEventListener('click', () => {
      const group = pill.closest('.product-option-group');
      group.querySelectorAll('.option-pill').forEach((p) => p.classList.remove('is-selected'));
      pill.classList.add('is-selected');

      const labelVal = group.querySelector('.product-option-group__selected-val');
      if (labelVal) labelVal.textContent = pill.dataset.optionValue;

      // Determine currently selected options
      const selectedOptions = Array.from(section.querySelectorAll('.product-option-group')).map((grp) => {
        const sel = grp.querySelector('.option-pill.is-selected');
        return sel ? sel.dataset.optionValue : null;
      });

      // Match variant
      const matchedVariant = variants.find((v) => {
        return selectedOptions.every((opt, idx) => v.options[idx] === opt);
      });

      if (matchedVariant) {
        if (variantInput) variantInput.value = matchedVariant.id;
        if (floatingBtn) floatingBtn.dataset.variantId = matchedVariant.id;

        // Update URL without page reload
        const url = new URL(window.location.href);
        url.searchParams.set('variant', matchedVariant.id);
        window.history.replaceState({}, '', url.toString());

        // Update price display
        if (priceEl) {
          priceEl.textContent = formatMoney(matchedVariant.price);
        }
        if (comparePriceEl) {
          if (matchedVariant.compare_at_price > matchedVariant.price) {
            comparePriceEl.textContent = formatMoney(matchedVariant.compare_at_price);
            comparePriceEl.classList.remove('is-hidden');
          } else {
            comparePriceEl.classList.add('is-hidden');
          }
        }

        // Update button & stock status
        updateStockStatus(matchedVariant);

        if (matchedVariant.available) {
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.querySelector('.product-cta-btn__text').textContent = 'Ajouter au panier';
          }
          if (floatingBtn) {
            floatingBtn.disabled = false;
            floatingBtn.querySelector('span').textContent = 'Ajouter';
          }
        } else {
          if (addBtn) {
            addBtn.disabled = true;
            addBtn.querySelector('.product-cta-btn__text').textContent = 'Épuisé';
          }
          if (floatingBtn) {
            floatingBtn.disabled = true;
            floatingBtn.querySelector('span').textContent = 'Épuisé';
          }
        }

        // Switch media if variant has featured_media
        if (matchedVariant.featured_media) {
          const mediaIndex = Array.from(slides).findIndex(
            (s) => s.dataset.mediaId == matchedVariant.featured_media.id
          );
          if (mediaIndex !== -1) {
            setActiveMedia(mediaIndex);
          }
        }
      }
    });
  });

  // Helper formatMoney (uses Shopify currency format or standard EUR fallback)
  function formatMoney(cents) {
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }

  // Helper updateStockStatus
  function updateStockStatus(variant) {
    if (!stockStatusEl) return;
    const invData = variantsInventory[variant.id] || {
      inventory_quantity: variant.inventory_quantity || 0,
      inventory_policy: variant.inventory_policy || 'deny',
      inventory_management: variant.inventory_management || null,
      available: variant.available,
    };

    const hasStock = !invData.inventory_management || invData.inventory_quantity > 0;
    const allowBackorder = invData.inventory_policy === 'continue';

    let html = '';
    if (hasStock) {
      html = `
          <div class="logistics-badge logistics-badge--success">
            <span class="status-dot status-dot--success"></span>
            <span class="logistics-badge__text">En stock au shop</span>
          </div>
        `;
    } else if (allowBackorder) {
      html = `
          <div class="logistics-badge logistics-badge--pending">
            <span class="status-dot status-dot--pending"></span>
            <span class="logistics-badge__text">Livrable au shop</span>
          </div>
        `;
    } else {
      html = `
          <div class="logistics-badge logistics-badge--danger">
            <span class="status-dot status-dot--danger"></span>
            <span class="logistics-badge__text">En rupture</span>
          </div>
        `;
    }

    stockStatusEl.innerHTML = html;

    const floatingStockTag = section.querySelector('.floating-quick-bar__stock-tag');
    if (floatingStockTag) {
      if (hasStock) {
        floatingStockTag.textContent = 'En stock au shop';
        floatingStockTag.style.color = '#1b8a36';
      } else if (allowBackorder) {
        floatingStockTag.textContent = 'Livrable au shop';
        floatingStockTag.style.color = '#1b8a36';
      } else {
        floatingStockTag.textContent = 'En rupture';
        floatingStockTag.style.color = '#e54d42';
      }
    }
  }

  // Stock Status Explanation Modal
  const stockModal = document.getElementById('StockModal-' + sectionId) || section.querySelector('[id^="StockModal-"]');
  const stockInfoBtn = section.querySelector('.js-stock-modal-open');

  if (stockModal && stockInfoBtn) {
    const closeBtns = stockModal.querySelectorAll('.js-stock-modal-close');

    function openStockModal() {
      stockModal.classList.add('is-open');
      stockModal.setAttribute('aria-hidden', 'false');
      stockInfoBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      const closeBtn = stockModal.querySelector('.stock-modal__close-btn');
      if (closeBtn) closeBtn.focus();
    }

    function closeStockModal() {
      stockModal.classList.remove('is-open');
      stockModal.setAttribute('aria-hidden', 'true');
      stockInfoBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      stockInfoBtn.focus();
    }

    stockInfoBtn.addEventListener('click', (e) => {
      e.preventDefault();
      openStockModal();
    });

    closeBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        closeStockModal();
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && stockModal.classList.contains('is-open')) {
        closeStockModal();
      }
    });
  }

  // 4. Quantity Stepper
  const qtyMinus = section.querySelector('.js-qty-minus');
  const qtyPlus = section.querySelector('.js-qty-plus');
  const qtyInput = section.querySelector('.js-qty-input');

  if (qtyMinus && qtyPlus && qtyInput) {
    function updateQtyMinusState() {
      const val = parseInt(qtyInput.value, 10) || 1;
      qtyMinus.disabled = val <= 1;
    }

    qtyMinus.addEventListener('click', () => {
      let val = parseInt(qtyInput.value, 10) || 1;
      if (val > 1) {
        qtyInput.value = val - 1;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      updateQtyMinusState();
    });

    qtyPlus.addEventListener('click', () => {
      let val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = val + 1;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      updateQtyMinusState();
    });

    qtyInput.addEventListener('input', updateQtyMinusState);
    qtyInput.addEventListener('change', () => {
      let val = parseInt(qtyInput.value, 10) || 1;
      if (val < 1) {
        qtyInput.value = 1;
      }
      updateQtyMinusState();
    });

    updateQtyMinusState();
  }

  // 5. AJAX Add to Cart & Cart Drawer Integration
  function addToCart(variantId, quantity, triggerBtn) {
    if (!variantId) return;

    if (triggerBtn) triggerBtn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 }),
    })
      .then((res) => res.json())
      .then(() => {
        if (triggerBtn) triggerBtn.classList.remove('is-loading');

        // Refresh Cart Drawer and open it
        if (window.cartDrawer && typeof window.cartDrawer.refresh === 'function') {
          window.cartDrawer.refresh().then(() => {
            window.cartDrawer.open();
          });
        } else if (window.cartDrawer && typeof window.cartDrawer.open === 'function') {
          window.cartDrawer.open();
        }
      })
      .catch((err) => {
        console.error('Erreur ajout au panier:', err);
        if (triggerBtn) triggerBtn.classList.remove('is-loading');
      });
  }

  // Main form submit handler
  const form = section.querySelector('.js-product-form');
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const vId = variantInput ? variantInput.value : null;
      const qVal = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      addToCart(vId, qVal, addBtn);
    });
  }

  // Complementary products quick-add buttons
  section.querySelectorAll('.js-comp-add-btn').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const vId = btn.dataset.variantId;
      addToCart(vId, 1, btn);
    });
  });

  // Floating quick add button
  if (floatingBtn) {
    floatingBtn.addEventListener('click', () => {
      const vId = floatingBtn.dataset.variantId || (variantInput ? variantInput.value : null);
      addToCart(vId, 1, floatingBtn);
    });
  }

  // 6. Floating Bar Visibility on Scroll
  if (floatingBar && addBtn) {
    floatingBar.classList.remove('is-visible'); floatingBar.setAttribute('aria-hidden', 'true'); let addBtnInView = true;
    let sliderInView = false;
    function updateFloatingBar() {
      if (!addBtnInView && !sliderInView) {
        floatingBar.classList.add('is-visible');
        floatingBar.setAttribute('aria-hidden', 'false');
      } else {
        floatingBar.classList.remove('is-visible');
        floatingBar.setAttribute('aria-hidden', 'true');
      }
    }
    const addObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        // addBtn is considered in view when intersecting
        addBtnInView = entry.isIntersecting;
        updateFloatingBar();
      });
    }, { threshold: 0 });
    addObserver.observe(addBtn);
    // Ensure correct initial visibility
    updateFloatingBar();
    // Observe collection slider wrapper to hide floating bar when in view
    const collectionSlider = document.getElementById('shopify-section-template--31845714755922__faq_support');
    if (collectionSlider) {
      const sliderObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          sliderInView = entry.isIntersecting;
          updateFloatingBar();
        });
      }, { threshold: 0 });
      sliderObserver.observe(collectionSlider);
    }
  }
}

function initAllProductSections() {
  document.querySelectorAll('.product-section').forEach(initProductSection);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllProductSections);
} else {
  initAllProductSections();
}

document.addEventListener('shopify:section:load', (e) => {
  const target = e.target.querySelector ? (e.target.querySelector('.product-section') || e.target) : e.target;
  if (target && target.classList && target.classList.contains('product-section')) {
    initProductSection(target);
  }
});
